import { SupabaseClient, createClient } from "@supabase/supabase-js"
import type { Database } from "./supabase"

let _supabaseClient: SupabaseClient<Database> | null = null
export const createSupabase = () => {
  if (null === _supabaseClient) {
    console.debug("> createSupabase")
    const supabaseUrl = process.env["SUPABASE_URL"]!
    const supabaseKey = process.env["SUPABASE_KEY"]!
    if (!supabaseUrl || !supabaseKey) {
      throw new Error("Supabase credentials missing.")
    }

    const client = createClient<Database>(supabaseUrl, supabaseKey)
    console.debug("Got supabase instance")
    _supabaseClient = client
  }
  return _supabaseClient
}

export const ensureLocalSupabase = () => {
  if (!isLocalSupabase()) {
    throw new Error("Make sure you are using a local supabase for tests!")
  }
}

const isLocalSupabase = () => {
  const supabaseUrl = process.env["SUPABASE_URL"]!
  const supabaseKey = process.env["SUPABASE_KEY"]!
  if (!supabaseUrl || !supabaseKey) {
    throw new Error("Supabase credentials missing.")
  }
  return (
    supabaseUrl.includes("://localhost:") ||
    supabaseUrl.includes("://127.0.0.1:")
  )
}
